// Shared referral entries for every service chatbot: one view explaining how
// inviting works, and one email box for the user who *was* invited. Both run on
// the existing endpoints (`check_referred` / `refer_user`) — the same referral
// the missions list already offers, surfaced as its own menu options.
import InviteFriendsView from "./InviteFriendsView.vue";
import userService from "@/services/userService";
import { referralRewardsKnownEmpty } from "./referralRewards";

export const INVITE_OPTION = {
  label: "Invitar colegas (ganan usos los dos)",
  nextIndex: "invite",
};

export const REFERRED_OPTION = {
  label: "Me invitó un colega: ingresar su correo",
  nextIndex: "referred_by",
};

export const REFERRAL_OPTIONS = [INVITE_OPTION, REFERRED_OPTION];

// The menu entries, or none when the service has nothing to give. Hiding the
// card alone was not enough: the option stayed in the menu and led to a step
// showing only its header, "¡Mientras más colegas invites, más usos gratis para
// todos! 🎁" — the same empty promise, one click deeper.
//
// Call this where the menu is built, never at module load: the answer arrives
// with `check_referred`, so anything evaluated at import time reads "unknown"
// forever. Unknown keeps the options, so a service nobody has asked about yet
// behaves exactly as it does today.
export const referralOptions = (serviceKey) =>
  referralRewardsKnownEmpty(serviceKey) ? [] : REFERRAL_OPTIONS;

// `vm` is the chatbot component — only used for its toaster.
//
// `service` es la clave corta del chatbot ("eureka", "tests", ...). Viaja
// hasta `refer_user`, que paga los usos de ESE servicio y no de los cinco. Sin
// ella el backend cae a su default —planificaciones— y quien fue invitado a
// Eureka termina con usos de planificaciones.
export const referralQuestions = (
  vm,
  nextQuestionIndex = "mainMessage",
  service = ""
) => ({
  invite: {
    name: "invite",
    text: "¡Mientras más colegas invites, más usos gratis para todos! 🎁",
    type: "custom-component",
    component: InviteFriendsView,
    answersLoaded: true,
    answers: [],
    dontShowNextButton: true,
    nextQuestionIndex,
    routine: () => {},
  },
  referred_by: {
    name: "referred_by",
    text: `<div class="text-left">
        <strong>¿Alguien te invitó a Utopie?</strong><br/>
        Escribe su correo y les cargamos usos gratis a los dos. Solo se puede
        una vez por cuenta.
      </div>`,
    type: "inputs",
    answersLoaded: true,
    answers: [
      {
        name: "email",
        type: "email",
        placeholder: "Correo de quien te invitó",
        class: "col-12 col-md-8 mb-2",
      },
    ],
    nextMessage: "¡Ganar usos!",
    extraFunction: (data) => {
      userService.referUser({ email: data.email, service }).then(
        (resp) => vm.$toasted.success(resp.message),
        (error) =>
          vm.$toasted.error(
            (error.response && error.response.data.message) ||
              "Error al referir usuario"
          )
      );
    },
    nextQuestionIndex,
    routine: () => {},
  },
});
